import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';

import { PermissionService } from './permission.service';

/**
 * Route-level permission gate factory (Implementation Architecture & Sprint Plan §8).
 * Shares PermissionService with the *appHasPermission directive so route-level and
 * element-level visibility can never drift apart.
 */
export function permissionGuard(permission: string): CanActivateFn {
  return () => {
    const permissionService = inject(PermissionService);
    const router = inject(Router);

    return permissionService.hasPermission(permission) ? true : router.parseUrl('/');
  };
}
